import axios from 'axios';
import env from 'react-dotenv';
import { toast } from 'react-toastify';

const baseUrl = axios.create({ baseURL: `${process.env.REACT_APP_API_URL}` });

export default baseUrl;
